import { Sidebar as ProSidebar, Menu, SubMenu } from 'react-pro-sidebar'
import { SideBarMenuItem } from './MenuItem'
import { MenuItems } from './items'
import { SideBarSubMenu } from './MenuGroup'
import './index.scss'
import { useTheme } from '../../services/theme'
import { Colors } from '../../types'
import {useAuth} from "../../services/authContext";

type Props = {
    collapsed: boolean
}

export const Sidebar = ({ collapsed = false }: Props) => {
    const theme = useTheme()
    const { me } = useAuth()
    return (
        <ProSidebar 
            backgroundColor='' 
            style={{ overflowY: 'auto', 
                backgroundColor: theme === 'dark' ? Colors.MAIN_DARK : Colors.MAIN_WHITE,
                color: theme === 'dark' ? Colors.MAIN_WHITE : Colors.MAIN_BLACK,
                height: '100%',
            }}
            collapsed={collapsed}
        >
            
            <Menu menuItemStyles={{
                icon: (params) => {
                    if (params.level > 0) return { margin: 0,}
                },
                button: (params) => {
                    if (params.level > 0) return { fontSize: 12,
                        backgroundColor: theme === 'dark' ? Colors.MAIN_DARK : Colors.MAIN_WHITE,
                        "&:hover": {
                            backgroundColor: theme === 'dark' ? `${Colors.MAIN_DARK} !important`: `${Colors.MAIN_LIGTH} !important`,
                            color: "white !important",
                        },
                    }
                    return { "&:hover": {
                            backgroundColor: theme === 'dark' ? `${Colors.MAIN_BLACK} !important`: `${Colors.MAIN_LIGTH} !important`,
                            color: "white !important",
                        },
                    }
                },
            }}>
                {
                    MenuItems.map((menuItem: any) => {
                        if(menuItem.admin && me?.role !== 'admin') return null
                        return !menuItem.items 
                            ? <SideBarMenuItem key={menuItem.name} icon={menuItem.icon} path={menuItem.path} name={menuItem.name}></SideBarMenuItem> 
                            : <SideBarSubMenu key={menuItem.name} icon={menuItem.icon} label={menuItem.name}>
                                {
                                    menuItem.items.map((subItem: any) => {
                                        return <SideBarMenuItem key={subItem.name} icon={subItem.icon} path={subItem.path} name={subItem.name}></SideBarMenuItem> 
                                    })
                                }
                            </SideBarSubMenu>
                    })
                }
            </Menu>
        </ProSidebar>
    )
}
